export default [
  {
    header: 'All',
  },
  {
    title: 'Mechanics',
    route: 'v2_blank1',
    icon: 'none',
  },
  {
    title: 'Science',
    route: 'v2_blank2',
    icon: 'none',
  },
  {
    title: 'Engineering',
    route: 'v2_blank3',
    icon: 'none',
  },
  {
    title: 'Control Systems',
    route: 'v2_blank4',
    icon: 'none',
  },
  
]
